export default __webpack_public_path__ + "static/media/simple-microsoftexcel.ecb8376f.svg";